import axios from "axios";
import NProgress from "nprogress";
import Vue from "vue";
const client = axios.create({
  baseURL: Vue.prototype.$apiUrl,
  withCredentials: false
});

client.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error.response);
  }
);

function GetStat() {
  const params = {
    action: "stat"
  };
  return client.get("stats.php", { params });
}

function GetStudentStat(id) {
  const params = {
    id: id,
    action: "sstat"
  };
  return client.get("stats.php", { params });
}

export { GetStat, GetStudentStat }